import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAutomationTemplateStepAddTagUpdateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAddTagAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			templateId,
			stepId,
			step,
			impersonationContext,
		}: {
			templateId: string;
			stepId: string;
			step: Api.IAddTagAutomationStep;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAddTagAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/AddTag/${encodeURIComponent(stepId)}`,
					impersonationContext,
				}),
				'PUT',
				step
			);
		},
		onError,
		onSuccess,
	});
}
